import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 敷地詳細入力
 * 三角形を追加するためのダイアログ
 */
class SiteBaseAndLength extends Dialog {
    _itemSite: marietta.webcad.item.Site;

    get itemSite(): marietta.webcad.item.Site {
      return this._itemSite;
    }

    set itemSite(item: marietta.webcad.item.Site) {
      this._itemSite = item;
    }

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);
      this.showHeaderCloseButton = false;

      // 情報をGET
      const id = 'dialogSiteBaseAndLength';
      let title = '';
      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'jp': title = '三斜入力'; break;
        default: title = '3 Diagonal Input'; break;
      }
      this.itemSite = marietta.webcad.WebCADGlobal.itemManager.lastCreatedItem as marietta.webcad.item.Site;
      const A = Math.round(this.itemSite.lines[0].partnerText.distance);
      const B = Math.round(this.itemSite.lines[1].partnerText.distance);
      const C = Math.round(this.itemSite.lines[2].partnerText.distance);

      let contents = '<div class="dialogPlanAreaTable menseki">\n';
      contents += '<div>\n';
      contents += '<div>底辺</div>\n';
      contents += '<div>\n';
      contents += '<form>\n';
      contents += `<input type="radio" id="radio_${this.itemSite.lines[0].index}" name="底辺" value="${this.itemSite.lines[0].index}">A</input> <input id="input${this.itemSite.lines[0].index}" autocomplete="off" class = "cordInp cordA" value="${A}" type="text"></input> mm<br>`;
      contents += `<input type="radio" id="radio_${this.itemSite.lines[1].index}" name="底辺" value="${this.itemSite.lines[1].index}">B</input> <input id="input${this.itemSite.lines[1].index}" autocomplete="off" class = "cordInp cordB" value="${B}" type="text"></input> mm<br>`;
      contents += `<input type="radio" id="radio_${this.itemSite.lines[2].index}" name="底辺" value="${this.itemSite.lines[2].index}">C</input> <input id="input${this.itemSite.lines[2].index}" autocomplete="off" class = "cordInp cordC" value="${C}" type="text"></input> mm<br>`;
      contents += '</form>\n';
      contents += '<div class="calculatedView">\n';
      contents += '<div class="altitudeView">高さ: </div>\n';
      contents += '<form>\n';
      contents += '<input id = "inputAltitude" value="" readonly></input> mm\n';
      contents += '</form>\n';
      contents += '<hr>\n';
      contents += '<div class="areaView">面積: </div>\n';
      contents += '<form>\n';
      contents += '<input id="area" readonly></input>m²\n';
      contents += '</form>\n';
      contents += '</div>\n';
      contents += '</div>\n';
      contents += '</div>\n';
      contents += '</div>\n';
      const footer = '<button id="okButton">OK</button> <button id="cancelButton"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';
      this.createDialog(id, title, contents, footer);

      (marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(1).layer_site as marietta.webcad.layer.SiteLayer).updateLineLockInfo();

      for (let i = 0; i < this.itemSite.lines.length; i += 1) {
        if (this.itemSite.lines[i].locked) {
          (<HTMLInputElement>document.getElementById(`input${this.itemSite.lines[i].index}`)).disabled = true;
        }

        document.getElementById(`radio_${this.itemSite.lines[i].index}`).addEventListener('change', (evt: any) => {
          this.changeBaseLine(parseFloat(evt.target.value));
        });
        if (this.itemSite.baseSideLine.index === this.itemSite.lines[i].index) {
          (<HTMLInputElement>document.getElementById(`radio_${this.itemSite.baseSideLine.index}`)).checked = true;
        }
      }

      document.getElementById('okButton').addEventListener('click', () => {
        if (document.getElementById('dialogContainer').querySelectorAll('alertDialog').length > 0) {
          return;
        }
        const sideA: number = parseFloat((<HTMLInputElement>document.getElementById(`input${this.itemSite.lines[0].index}`)).value);
        const sideB: number = parseFloat((<HTMLInputElement>document.getElementById(`input${this.itemSite.lines[1].index}`)).value);
        const sideC: number = parseFloat((<HTMLInputElement>document.getElementById(`input${this.itemSite.lines[2].index}`)).value);

        if ((Number.isNaN(sideA) || sideA === null) || (Number.isNaN(sideB) || sideB === null) || (Number.isNaN(sideC) || sideC === null)) {
          marietta.webcad.WebCADGlobal.showAlert('入力が不足しています');
          return;
        }
        const sides: number[] = [];
        if (Number.isNaN(parseFloat((<HTMLInputElement>document.getElementById('inputAltitude')).value))) {
          sides.push(sideA);
          sides.push(sideB);
          sides.push(sideC);
          const sortNumber = (a: number, b: number) => a - b;
          sides.sort(sortNumber);
          if (sides[0] + sides[1] <= sides[2]) {
            marietta.webcad.WebCADGlobal.showAlert('値が不正です');
            return;
          }
        } else {
          switch (this.itemSite.baseSideLine.index) {
            case 0:
              sides.push(sideB);
              sides.push(sideC);
              break;
            case 1:
              sides.push(sideC);
              sides.push(sideA);
              break;
            case 2:
              sides.push(sideA);
              sides.push(sideB);
              break;
            default:
              break;
          }
          if (sides[0] + sides[1] < parseFloat((<HTMLInputElement>document.getElementById('inputAltitude')).value)) {
            marietta.webcad.WebCADGlobal.showAlert('値が不正です');
            // return false;
          }
        }

        this.itemSite.chageSiteShape(sideA, sideB, sideC);
        this.close();
        marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
        (marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(1).layer_site as marietta.webcad.layer.SiteLayer).updateLineLockInfo();
        marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.updateTranslate();
      });

      document.getElementById('cancelButton').addEventListener('click', () => {
        if (document.getElementById('dialogContainer').querySelectorAll('alertDialog').length > 0) {
          return;
        }
        this.itemSite.deleteMe();
        (marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(1).layer_site as marietta.webcad.layer.SiteLayer).updateLineLockInfo();
        this.close();
      });

      this.setInputFilter(document.getElementsByClassName('cordInp'), (value) => /^-?\d*[.,]?\d*$/.test(value));
      let numarea:number = parseFloat(this.calculateArea());
      numarea /= 1e+6;
      numarea = Math.round(numarea);
      if (numarea.toString().indexOf('.') !== -1) numarea = Math.round(numarea);
      (<HTMLInputElement>document.getElementById('area')).value = numarea.toString();

      this.setTakasaFromAllSides();
    }

    setInputFilter(textbox, inputFilter) {
      const scope: marietta.webcad.view.dialog.SiteBaseAndLength = this;
      ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach((event) => {
        for (let i = 0; i < textbox.length; i += 1) {
          textbox[i].addEventListener(event, function () {
            if (inputFilter(this.value)) {
              this.oldValue = this.value;
              this.oldSelectionStart = this.selectionStart;
              this.oldSelectionEnd = this.selectionEnd;
              let numarea:any = parseFloat(scope.calculateArea());
              numarea /= 1e+6;
              numarea = Math.round(numarea);
              if (numarea.toString().indexOf('.') !== -1) numarea = Math.round(numarea);
              (<HTMLInputElement>document.getElementById('area')).value = numarea;
              scope.setTakasaFromAllSides();
            // eslint-disable-next-line no-prototype-builtins
            } else if (this.hasOwnProperty('oldValue')) {
              this.value = this.oldValue;
              this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
              let numarea:any = parseFloat(scope.calculateArea());
              numarea /= 1e+6;
              numarea = Math.round(numarea);
              if (numarea.toString().indexOf('.') !== -1) numarea = Math.round(numarea);
              (<HTMLInputElement>document.getElementById('area')).value = numarea;
              scope.setTakasaFromAllSides();
            }
          });
        }
      });
    }

    isValidInput = (evt) => {
      // eslint-disable-next-line no-param-reassign
      evt = (evt) || window.event;
      const decimal = /^[-+]?[0-9]+\.[0-9]+$/;
      if ((evt.target.value).match(decimal)) {
        if (document.querySelector(evt.target).classList.contains('cordA')) {
        //
        }
      } else {
        console.log('ff');
      }
    }

    changeBaseLine(value) {
      this.itemSite.showAltitude(this.itemSite.lines[value - 1]);
      this.setTakasaFromAllSides();
    }

    calculateArea() {
      let area: any = 0;
      let s: any = 0;
      let sideA: number = parseInt((<HTMLInputElement>document.getElementById(`input${this.itemSite.lines[0].index}`)).value, 10);
      let sideB: number = parseInt((<HTMLInputElement>document.getElementById(`input${this.itemSite.lines[1].index}`)).value, 10);
      let sideC: number = parseInt((<HTMLInputElement>document.getElementById(`input${this.itemSite.lines[2].index}`)).value, 10);
      sideA = (sideA === null ? 0 : sideA);
      sideB = (sideB === null ? 0 : sideB);
      sideC = (sideC === null ? 0 : sideC);
      if (Number.isNaN(sideA) || Number.isNaN(sideB) || Number.isNaN(sideC)) {
        (<HTMLInputElement>document.getElementById('area')).value = '0';
      }
      s = (sideA + sideB + sideC) / 2;
      area = Math.round(Math.sqrt(s * (s - sideA) * (s - sideB) * (s - sideC)) * 100) / 100;
      area = Math.round(area);
      return area;
    }

    /**
     * ３辺から、高さを求める
     * */
    setTakasaFromAllSides(): void {
      const myMenseki: number = this.calculateArea();
      // const baseNo: number = this.itemSite.baseSideLine.index;
      const baseLen: number = parseFloat((<HTMLInputElement>document.getElementById(`input${this.itemSite.baseSideLine.index}`)).value);
      let takasa: number;

      // 高さを逆算
      takasa = Math.round(((myMenseki * 2) / baseLen));
      takasa = Math.round(takasa);
      if (this.itemSite.altitudelineText._distance !== takasa) takasa = this.itemSite.altitudelineText._distance;
      // テキストボックスに代入
      (<HTMLInputElement>document.getElementById('inputAltitude')).value = String(takasa);
    }
}
export default SiteBaseAndLength;
